<template>
    <div class="mx-auto col-lg-5 col-md-8 col-sm-12 header-margin">
        <div class="text-center">
            <div>
                <img class="success_email_img p-4" src="./images/success_contact.png">
            </div>

            <div class="show-check-email-message">
                <h5 class="text-black-50" v-html="$t('auth.changeEmailRequestConfirm.text')">
                </h5>
            </div>

            <div class="pt-5">
                <router-link to="/" class="btn btn-primary" @click.native="handleOnClickLogout()" role="button">{{$t('auth.changeEmailRequestConfirm.button') }}</router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import AuthUtil from '../../utils/AuthUtil';
    import UserService from "../../services/UserService";

    export default {
        name: 'change-mail-request-confirm',
        methods: {
            async handleOnClickLogout(e) {
                try {
                    await UserService.revokeToken(AuthUtil.getAuthToken());
                } catch (e) {}
                AuthUtil.clearAuth();
                this.isOpenMenu = false;
                this.$router.go('/login');
            },
        }
    }
</script>

<style scoped>
    .success_email_img {
        max-width: 150px;
        width: 100%;
    }
    .show-check-email-message >>> br {
            display: inline;
    }
    @media screen and (max-width: 767px) {
        .show-check-email-message {
            text-align: left;
        }
        .show-check-email-message >>> br {
            display: none;
        }
    }
</style>
